// extracted by mini-css-extract-plugin
export default {"loader":"SplitComparison_loader__a5PmN","rotation":"SplitComparison_rotation__mVqMQ"};